"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPTIONS_YES_NO = exports.OPTION_NO = exports.OPTION_YES = void 0;
exports.OPTION_YES = ['Y', 'YES'];
exports.OPTION_NO = ['N', 'NO'];
exports.OPTIONS_YES_NO = [exports.OPTION_YES, exports.OPTION_NO];
//# sourceMappingURL=constants.js.map